import type React from 'react'
import { cn } from '../../../../shared/cn'
import { applyPolishOrphans } from '../../../../shared/preventPolishOrphans'

export function H2({ className, children, ...props }: React.ComponentPropsWithoutRef<'h2'>) {
  return (
    <h2 {...props} className={cn('font-bold text-2xl lg:font-bold lg:text-3xl', className)}>
      {applyPolishOrphans(children)}
    </h2>
  )
}
